/** token状态 */
export enum tokenTypeEnum {
  /** 到期 */
  expire = 'expire',
  /** 即将到期 */
  willExpire = 'willExpire',
  /** 正常 */
  continuing = 'continuing',
}
/** 加载状态 */
export enum loadingStatus {
  loading = 'loading',
  success = 'success',
  fail = 'fail',
};
/** 编辑类型枚举 */
export enum EditTypeEnum {
  /** 新增 */
  add = 'add',
  /** 新增草稿箱 */
  addDrafts = 'addDrafts',
  /** 详情 */
  detail = 'detail',
  /** 编辑 */
  edit = 'edit',
  /** 删除 */
  delete = 'delete',
  /** 版本升级 */
  upgrade = 'upgrade',
  /** 下载 */
  download = 'download',
  /** 查询已执行脚本 */
  queryExecute = 'queryExecute',
  /** 查询可执行脚本 */
  queryUnexecute = 'queryUnexecute',
  /** 打印合同 */
  printContract = 'printContract',
  /** 提交审核 */
  submitReview = 'submitReview',
  /** 撤回审核 */
  unSubmitReview = 'unSubmitReview',
  /** 审核 */
  audit = 'audit',
  /** 下单 */
  sign = 'sign',
  /** 完结 */
  complete = 'complete',
  /** 指派QC */
  selectQC = 'selectQC',
  /** 跟踪 */
  attachOp = 'attachOp',
  /** 到货完成 */
  arrivalComplete = 'arrivalComplete',
  /** 付款 */
  payment = 'payment',
  /** 结算 */
  settleAccounts = 'settleAccounts',
  /** 作废审核 */
  forInvalid = 'forInvalid',
  /** 支付完成 */
  paymentCom = 'paymentCom',
  /** 复制新增 */
  copyCreate = 'copyCreate',
  /** 作废 */
  invalid = 'invalid',
  /** 撤销 */
  writeOff = 'writeOff',
  /** 绑定ShipmentId */
  bindShipmentId = 'bindShipmentId',
  /** 通知发货 */
  readyDelivery = 'readyDelivery',
  /** 禁用 */
  disabled = 'disabled',
  /** 启用 */
  enabled = 'enabled',
  /** 授权 */
  authorize = 'authorize',
  /** 提交复核 */
  recheck = 'recheck',
  /** 确认收货 */
  inbound = 'inbound',
  /** 取消收货 */
  cancelReceipt = 'cancelReceipt',
  /** 确认收货 */
  confirmReceipt = 'confirmReceipt',
  /** 销单 */
  confirmOrder = 'confirmOrder',
  /** 退货 */
  returnGoods = 'returnGoods',
  /** 确认完成 */
  confirmComplete = 'confirmComplete',
  /** 取消 */
  cancel = 'cancel',
  /** 确认出库 */
  confirmDelivery = 'confirmDelivery',
  /** 一键入库 */
  oneKeyInbound = 'oneKeyInbound',
  /* 全部释放 */
  release = 'release',
  /* 部分释放 */
  partialRelease = 'partialRelease',
  /** 导出 */
  export = 'export',
  /** 提交 */
  submit = 'submit',
  /** 通过 */
  passed = 'passed',
  /** 驳回 */
  rejected = 'rejected',
}
/** 编辑类型文字枚举 */
export enum EditTypeStrEnum {
  add = '新增',
  addDrafts = '新增',
  detail = '详情',
  edit = '编辑',
  delete = '删除',
  upgrade = '版本升级',
  download = '下载',
  queryExecute = '查询已执行脚本',
  queryUnexecute = '查询可执行脚本',
  printContract = '打印合同',
  submitReview = '提交审核',
  unSubmitReview = '撤回审核',
  audit = '审核',
  sign = '下单',
  complete = '完结',
  selectQC = '指派QC',
  attachOp = '跟踪',
  arrivalComplete = '到货完成',
  payment = '付款',
  settleAccounts = '结算',
  forInvalid = '作废审核',
  paymentCom = '支付完成',
  copyCreate = '复制新增',
  invalid = '作废',
  writeOff = '核销',
  bindShipmentId = '绑定ShipmentId',
  readyDelivery = '通知发货',
  disabled = '禁用',
  enabled = '启用',
  authorize = '授权',
  recheck = '开始复核',
  inbound = '确认收货',
  cancelReceipt = '取消收货',
  confirmReceipt = '确认入库',
  confirmOrder = '销单',
  returnGoods = '退货',
  confirmComplete = '确认完成',
  cancel = '取消',
  confirmDelivery = '确认出库',
  oneKeyInbound = '一键入库',
  release = '全部释放',
  partialRelease = '部分释放',
  export = '导出',
  submit = '提交',
  passed = '通过',
  rejected = '驳回',
}

export enum API_STATUS_ENUM {
  /** 未开始 */
  NOT_START = 'NOT_START',
  /** 加载中 */
  LOADING = 'LOADING',
  /** 加载成功 */
  SUCCESS = 'SUCCESS',
  /** 加载失败 */
  ERROR = 'ERROR',
}
